var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42105 10.3785V11.2H6.47368C6.70621 11.2 6.89474 11.3791 6.89474 11.6C6.89474 11.8209 6.70621 12 6.47368 12H5H3.52632C3.29379 12 3.10526 11.8209 3.10526 11.6C3.10526 11.3791 3.29379 11.2 3.52632 11.2H4.57895V10.3785C2.5706 10.1779 1 8.56018 1 6.6C1 6.3791 1.18853 6.2 1.42105 6.2C1.65358 6.2 1.84211 6.3791 1.84211 6.6C1.84211 8.2542 3.25874 9.6 5 9.6C6.74126 9.6 8.1579 8.2542 8.1579 6.6C8.1579 6.3791 8.34642 6.2 8.57895 6.2C8.81147 6.2 9 6.3791 9 6.6C9 8.56018 7.42941 10.1779 5.42105 10.3785ZM5 9C6.50915 9 7.73684 7.83369 7.73684 6.4V2.6C7.73684 1.16631 6.50915 0 5 0C3.49085 0 2.26316 1.16631 2.26316 2.6V6.4C2.26316 7.83369 3.49085 9 5 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 2.00012L1.00021 10.0001",
    stroke: "#D23333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/muteIcon.545e84083d2ef5294e4b005ac73565b4.svg";
export { ForwardRef as ReactComponent };